// extracted by mini-css-extract-plugin
export default {"eventPreview":"EventPreview_eventPreview__igaw+","field":"EventPreview_field__W8QhQ","label":"EventPreview_label__TADkH","value":"EventPreview_value__SJN6b"};